import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="container-main py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-movie-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">欧美一区二区</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              专业欧美影视内容分区导航平台，精准划分欧美一区二区资源，提供高清流畅的分区浏览体验。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-100 mb-4">
              内容分区
            </h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-background-100 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-100 mb-4">
              快速链接
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-background-100 transition-colors">首页</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-background-100 transition-colors">关于我们</Link>
              </li>
              <li>
                <a href="#" className="text-sm text-background-400 hover:text-background-100 transition-colors">隐私政策</a>
              </li>
              <li>
                <a href="#" className="text-sm text-background-400 hover:text-background-100 transition-colors">服务条款</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-100 mb-4">
              联系我们
            </h4>
            <ul className="space-y-2 text-sm text-background-400">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <span>contact@oumei-yiqierqu.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line"></i>
                <span>北京市朝阳区影视产业园区</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line"></i>
                <span>+86 10-8888-6666</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-700 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2026 欧美一区二区·高清内容聚合平台 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-background-500 hover:text-background-200 transition-colors" aria-label="微博">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="text-background-500 hover:text-background-200 transition-colors" aria-label="微信">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="text-background-500 hover:text-background-200 transition-colors" aria-label="B站">
              <i className="ri-bilibili-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}